import { connect } from 'react-redux'
import SchoolTeam from './school-team'
import { withMe } from 'pobble-components/dist/pobble-user'
import { getFetchSchoolTeamRequest } from '../../../../stores/school-team/school-team.selectors'
import { fetchSchoolTeam } from '../../../../stores/school-team/school-team.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { me, meRequest }) => {
  const fetchSchoolTeamRequest = getFetchSchoolTeamRequest(state)
  return {
    schoolId: !meRequest.pending && me && me.account.teacher_type.school.id,
    pending: fetchSchoolTeamRequest.pending
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

const mergeProps = (stateProps, { dispatch }) => ({
  ...stateProps,
  onMount: () =>
    dispatch(fetchSchoolTeam(stateProps.schoolId)).catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(SchoolTeam)
)
